var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Col, Row } from "@folio/stripes/components";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormattedMessage, useIntl } from "react-intl";
import { createPerformanceStatisticsReportSchema } from "../../../utils/validationUtils";
import { generatePerformanceStatisticsReport } from "../../../api/reportsService";
import { DISPLAY_DATE_FORMAT, toApiDate } from "../../../utils/dateUtils";
import { RecekDatepicker } from "../../inputs/RecekDatepicker";
import { useReportMutation } from "../../../hooks/useReportMutation";
import { ReportSubmitSection } from "./ReportSubmitSection";
var getDefaultValues = function () { return ({
    periodFrom: "",
    periodTo: "",
}); };
var transformFormToApiParams = function (data) {
    var _a, _b;
    return ({
        periodFrom: (_a = toApiDate(data.periodFrom)) !== null && _a !== void 0 ? _a : "",
        periodTo: (_b = toApiDate(data.periodTo)) !== null && _b !== void 0 ? _b : "",
    });
};
export var PerformanceStatisticsReportForm = function () {
    var formatMessage = useIntl().formatMessage;
    var _a = useForm({
        resolver: zodResolver(createPerformanceStatisticsReportSchema(formatMessage)),
        defaultValues: getDefaultValues(),
    }), control = _a.control, handleSubmit = _a.handleSubmit;
    var reportMutation = useReportMutation({
        reportType: "performance-statistics",
        generateReport: function (ky, data) {
            return generatePerformanceStatisticsReport(ky, transformFormToApiParams(data));
        },
        successMessageId: "ui-br-agency.outputs.performance-statistics.success.generate",
        errorMessageId: "ui-br-agency.outputs.performance-statistics.error.generate",
    });
    return (React.createElement("form", { onSubmit: handleSubmit(function (data) { return reportMutation.mutate(data); }) },
        React.createElement("h2", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.report.performance-statistics" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.performance-statistics.description" })),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 4 },
                React.createElement(Controller, { control: control, name: "periodFrom", render: function (_a) {
                        var _b;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekDatepicker, __assign({}, field, { labelId: "ui-br-agency.outputs.performance-statistics.field.periodFrom", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, required: true, backendDateStandard: "ISO 8601", dateFormat: DISPLAY_DATE_FORMAT })));
                    } })),
            React.createElement(Col, { xs: 12, md: 4 },
                React.createElement(Controller, { control: control, name: "periodTo", render: function (_a) {
                        var _b;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekDatepicker, __assign({}, field, { labelId: "ui-br-agency.outputs.performance-statistics.field.periodTo", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, required: true, backendDateStandard: "ISO 8601", dateFormat: DISPLAY_DATE_FORMAT })));
                    } }))),
        React.createElement(ReportSubmitSection, { reportJob: reportMutation.reportJob, isLoading: reportMutation.isLoading, generateButtonId: "ui-br-agency.outputs.performance-statistics.button.generate", successMessage: reportMutation.successMessage, onSuccessDismiss: reportMutation.clearSuccessMessage, errorModalOpen: reportMutation.errorModalOpen, errorMessage: reportMutation.errorMessage, onErrorClose: reportMutation.closeErrorModal })));
};
